import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { MultiPropertyResidenciesDataGrid } from './MultiPropertyResidenciesDataGrid';
// import { FormerResidentsTable } from 'src/pages/ResidentsPage/FormerResidentsTable';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import ResidentModal from 'src/components/resident/ResidentModal';
import { TenanciesBatchActions } from 'src/components/property/TenanciesBatchActions';
// import { useTranslation } from 'react-i18next';

export const ResidentsTabContent = observer(_ref => {
  var _store$homeDashboardS3, _store$homeDashboardS4;
  let searchString = _ref.searchString,
    searchStatus = _ref.searchStatus;
  // const { t } = useTranslation();
  const classes = useStyles();
  const store = useStore();
  const selectedUnit = store.fse.FSEBillModalData;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRows = _useState2[0],
    setSelectedRows = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    residentModalIsOpen = _useState4[0],
    setResidentModalIsOpen = _useState4[1];
  const _useState5 = useState('overview'),
    _useState6 = _slicedToArray(_useState5, 2),
    activeTab = _useState6[0],
    setActiveTab = _useState6[1];
  const _useState7 = useState('livable-solution'),
    _useState8 = _slicedToArray(_useState7, 2),
    livableTab = _useState8[0],
    setLivableTab = _useState8[1];
  const closeResidentModal = () => setResidentModalIsOpen(false);
  const openResidentModal = tab => {
    if (['billing-settings', 'livable-solution', 'occupancy'].includes(tab)) {
      setActiveTab('livable-solution');
      setLivableTab(tab);
    } else {
      setActiveTab(tab);
    }
    setResidentModalIsOpen(true);
  };
  useEffect(() => {
    setSelectedRows([]);
  }, [searchStatus, searchString]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(MultiPropertyResidenciesDataGrid, {
    key: 'ResidentsTabContent-MultiPropertyResidenciesDataGrid',
    residenciesFilterStatus: searchStatus,
    searchKey: searchString,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows,
    propertyIds: store.homeDashboardStore.getCurrentCompanyPropertiesIdsByNavSelection,
    parentToggleRefreshCallback: () => {
      var _store$homeDashboardS, _store$homeDashboardS2;
      return (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.companyResidentsTabOptions) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.updateModel({
        refreshResidentsFlag: !((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS2 !== void 0 && (_store$homeDashboardS2 = _store$homeDashboardS2.companyResidentsTabOptions) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.refreshResidentsFlag)
      });
    }
  }), /*#__PURE__*/React.createElement(ResidentModal, {
    key: "ResidentsTabContent-resident-modal",
    accountId: selectedUnit.accountId,
    activeResidency: (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.buildingInformation) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.buildingAddress,
    activeTab: activeTab,
    isOpen: residentModalIsOpen,
    handleClose: closeResidentModal,
    handleOpen: openResidentModal,
    livableTab: livableTab,
    propertyId: (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.id,
    residencyId: selectedUnit.residencyId,
    setActiveTab: setActiveTab,
    unitName: selectedUnit.unitName,
    parentToggleRefreshCallback: () => {
      var _store$homeDashboardS5, _store$homeDashboardS6;
      return (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.companyResidentsTabOptions) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.updateModel({
        refreshResidentsFlag: !((_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS6 !== void 0 && (_store$homeDashboardS6 = _store$homeDashboardS6.companyResidentsTabOptions) !== null && _store$homeDashboardS6 !== void 0 && _store$homeDashboardS6.refreshResidentsFlag)
      });
    }
  }), store.residenciesMultiActionStore.selectedDetails.length > 0 && /*#__PURE__*/React.createElement(TenanciesBatchActions, null));
});